__turbopack_export_value__({
  "galleryItem": "ProjectModal-module__Uee6uW__galleryItem",
  "linkCard": "ProjectModal-module__Uee6uW__linkCard",
  "modal-fade-in": "ProjectModal-module__Uee6uW__modal-fade-in",
  "projectModalClose": "ProjectModal-module__Uee6uW__projectModalClose",
  "projectModalContent": "ProjectModal-module__Uee6uW__projectModalContent",
  "projectModalGallery": "ProjectModal-module__Uee6uW__projectModalGallery",
  "projectModalLinksGrid": "ProjectModal-module__Uee6uW__projectModalLinksGrid",
  "projectModalOverlay": "ProjectModal-module__Uee6uW__projectModalOverlay",
});
